module.exports = __webpack_public_path__ + "img/logo.f7a992a8.png";